import { api, setAuthToken } from "./base";
import axios from "axios";
import { getAnyInitData, getInitDataHeaderName } from "../lib/miniApp";
import { matchesInsufficientBalanceText } from "../lib/insufficientBalanceError";
import { requestOpenTopUpModal } from "../lib/topUpModalBridge";
import { wsManager, } from "../lib/websocket";
export const createSong = async (data) => {
    try {
        const accessToken = localStorage.getItem("accessToken");
        if (!accessToken) {
            throw new Error("Access token is missing");
        }
        setAuthToken(accessToken);
        const response = await api.post("/poems/", data);
        return response.data;
    }
    catch (error) {
        if (axios.isAxiosError(error)) {
            console.error("Error creating song:", error.response?.data);
        }
        else {
            console.error("Unexpected error:", error);
        }
        throw error;
    }
};
export const performSong = async (data) => {
    try {
        const accessToken = localStorage.getItem("accessToken");
        if (!accessToken) {
            throw new Error("Access token is missing");
        }
        const response = await api.post("/generate-audio/", data, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        });
        console.log("Промежуточный результат:", response.data.audio_url);
        const audioLinkElement = document.getElementById("audio-link");
        if (audioLinkElement) {
            audioLinkElement.href = response.data.audio_url;
            audioLinkElement.textContent = "Слушать аудиофайл";
        }
        else {
            console.error('Элемент с id "audio-link" не найден');
        }
        return response.data;
    }
    catch (error) {
        if (axios.isAxiosError(error)) {
            console.error("Error performing song:", error.response?.data);
        }
        else {
            console.error("Unexpected error:", error);
        }
        throw error;
    }
};
export const downloadAndSaveAudio = async (audioUrl, songId) => {
    try {
        const accessToken = localStorage.getItem("accessToken");
        if (!accessToken) {
            throw new Error("Access token is missing");
        }
        const response = await api.post("/download-audio/", { audio_url: audioUrl, song_id: songId }, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        });
        console.log("Аудиофайл сохранен:", response.data);
        return response.data;
    }
    catch (error) {
        if (axios.isAxiosError(error)) {
            console.error("Error saving audio file:", error.response?.data);
        }
        else {
            console.error("Unexpected error:", error);
        }
        throw error;
    }
};
export const getSongVariants = async (songId) => {
    try {
        const accessToken = localStorage.getItem("accessToken");
        if (!accessToken) {
            throw new Error("Access token is missing");
        }
        setAuthToken(accessToken);
        const response = await api.get(`/songs/${songId}/variants/`);
        return response.data;
    }
    catch (error) {
        if (axios.isAxiosError(error)) {
            console.error("Error fetching song variants:", error.response?.data);
        }
        else {
            console.error("Unexpected error:", error);
        }
        throw error;
    }
};
export const generateAudioForVariant = async (variantId) => {
    try {
        const accessToken = localStorage.getItem("accessToken");
        if (!accessToken) {
            throw new Error("Access token is missing");
        }
        setAuthToken(accessToken);
        const response = await api.post(`/variants/${variantId}/generate-audio/`);
        return response.data.audio_url;
    }
    catch (error) {
        if (axios.isAxiosError(error)) {
            console.error("Error generating audio:", error.response?.data);
        }
        else {
            console.error("Unexpected error:", error);
        }
        throw error;
    }
};
export const getPerformedSongs = async () => {
    try {
        const accessToken = localStorage.getItem("accessToken");
        if (!accessToken) {
            throw new Error("Access token is missing");
        }
        setAuthToken(accessToken);
        const response = await api.get("/user/performed-songs/");
        return response.data;
    }
    catch (error) {
        if (axios.isAxiosError(error)) {
            console.error("Error fetching performed songs:", error.response?.data);
        }
        else {
            console.error("Unexpected error:", error);
        }
        throw error;
    }
};
export const updateSongVariantText = async (songId, variantId, textIndex, newText) => {
    try {
        const accessToken = localStorage.getItem("accessToken");
        if (!accessToken) {
            throw new Error("Access token is missing");
        }
        setAuthToken(accessToken);
        const response = await api.patch(`/songs/${songId}/variants/${variantId}/${textIndex}/`, { text: newText });
        console.log("Текст обновлен:", response.data);
        return response.data;
    }
    catch (error) {
        if (axios.isAxiosError(error)) {
            console.error("Error updating song variant text:", error.response?.data);
        }
        else {
            console.error("Unexpected error:", error);
        }
        throw error;
    }
};
export const getUserSongs = async () => {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) {
        throw new Error("Access token is missing");
    }
    const response = await api.get("/user/songs/", {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    });
    return response.data;
};
/** Как в списке «Мои песни»: есть публичное аудио с URL */
export function songHistoryItemHasVisibleAudio(song) {
    return song.audios?.some((a) => Boolean(a.url && a.is_show)) ?? false;
}
/** Pending хранит song.id; в истории совпадение может быть по id песни или text_id */
export function findSongHistoryItemForPendingMusic(songs, pendingSongId) {
    return songs.find((s) => s.id === pendingSongId ||
        (s.text_id != null && s.text_id === pendingSongId));
}
/**
 * Сигнатура истории для клиентского «догона», если нет song_id (legacy storage).
 */
export function songsHistoryMusicSignature(songs) {
    return [...songs]
        .sort((a, b) => a.id - b.id)
        .map((s) => {
        const urls = s.audios
            .filter((a) => a.url && a.is_show)
            .map((a) => a.url)
            .sort()
            .join(",");
        return `${s.id}:${urls}`;
    })
        .join("|");
}
export const getSongHistory = async (params) => {
    const initData = getAnyInitData();
    const headers = {};
    if (initData) {
        headers[getInitDataHeaderName()] = initData;
    }
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
        headers["Authorization"] = `Bearer ${accessToken}`;
    }
    // Используем POST /api/v1/public/songs/search согласно API
    const search = params?.search?.trim();
    const requestBody = {
        limit: params?.limit || 20,
        offset: params?.offset || 0,
        // Ключ добавляем только при непустом запросе: бэк мапит `search` в
        // `filters.search` по признаку `is not None`, и пустая строка дала бы
        // бессмысленный ILIKE '%%'.
        ...(search ? { search } : {}),
    };
    const response = await api.post("/api/v1/public/songs/search", requestBody, {
        headers,
    });
    const data = response.data;
    // Обрабатываем разные форматы ответа
    if (Array.isArray(data)) {
        return {
            items: data,
            results: data,
            total: data.length,
            limit: params?.limit || 20,
            offset: params?.offset || 0,
        };
    }
    // Если это объект с results или items
    return {
        items: data.items || data.results || [],
        results: data.results || data.items || [],
        total: data.total ?? (data.results?.length || data.items?.length || 0),
        // Дефолта НЕТ намеренно: подпись «N треков» должна отличать «бэк не отдал
        // поле» (старая версия — подпись прячем) от честного нуля.
        audios_total: typeof data.audios_total === "number" ? data.audios_total : undefined,
        limit: data.limit ?? params?.limit ?? 20,
        offset: data.offset ?? params?.offset ?? 0,
    };
};
export const searchGenres = async (params) => {
    const initData = getAnyInitData();
    const headers = {};
    if (initData) {
        headers[getInitDataHeaderName()] = initData;
    }
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
        headers["Authorization"] = `Bearer ${accessToken}`;
    }
    const response = await api.post("/api/v1/public/songs/genres/search", params || {}, {
        headers,
    });
    return response.data.results || [];
};
export const searchReasons = async (params) => {
    const initData = getAnyInitData();
    const headers = {};
    if (initData) {
        headers[getInitDataHeaderName()] = initData;
    }
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
        headers["Authorization"] = `Bearer ${accessToken}`;
    }
    const response = await api.post("/api/v1/public/songs/reasons/search", params || {}, {
        headers,
    });
    return response.data.results || [];
};
export const searchRecipients = async (params) => {
    const initData = getAnyInitData();
    const headers = {};
    if (initData) {
        headers[getInitDataHeaderName()] = initData;
    }
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
        headers["Authorization"] = `Bearer ${accessToken}`;
    }
    const response = await api.post("/api/v1/public/songs/recipients/search", params || {}, {
        headers,
    });
    return response.data.results || [];
};
// Создание текста через ИИ (соответствует /api/v1/public/texts/create)
export const createNewSong = async (data) => {
    const initData = getAnyInitData();
    const headers = {};
    if (initData) {
        headers[getInitDataHeaderName()] = initData;
    }
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
        headers["Authorization"] = `Bearer ${accessToken}`;
    }
    const response = await api.post("/api/v1/public/texts/create", data, {
        headers,
    });
    return response.data;
};
function tryOpenTopUpFromWsPayload(payload) {
    const ext = payload;
    const text = [ext.result_status, ext.message, ext.detail]
        .filter(Boolean)
        .join(" ");
    if (matchesInsufficientBalanceText(text)) {
        requestOpenTopUpModal();
    }
}
/**
 * Ожидает результат генерации песни через WebSocket
 * @param wsEventId - ID события WebSocket
 * @param timeout - Таймаут в миллисекундах (по умолчанию 5 минут)
 * @returns Promise с результатом генерации песни
 */
export const waitForSongGeneration = async (wsEventId, timeout = 5 * 60 * 1000) => {
    try {
        await wsManager.connect(true);
    }
    catch (e) {
        console.error("WebSocket connect before waitForSongGeneration:", e);
    }
    return new Promise((resolve, reject) => {
        let timeoutId = null;
        // Устанавливаем таймаут
        timeoutId = setTimeout(() => {
            wsManager.unsubscribe(wsEventId);
            reject(new Error("Timeout waiting for song generation"));
        }, timeout);
        // Подписываемся на уведомления
        wsManager.subscribe(wsEventId, async (notification) => {
            const payload = notification.payload;
            console.log("WebSocket notification received:", {
                ws_event_id: payload.ws_event_id,
                expected_ws_event_id: wsEventId,
                type: payload.type,
                status: payload.status,
                result_status: payload.result_status,
                object_id: payload.object_id,
            });
            // Проверяем, что это уведомление для нашего ws_event_id
            if (payload.ws_event_id !== wsEventId) {
                console.log("WebSocket notification ws_event_id mismatch, ignoring");
                return;
            }
            // Проверяем статус успеха - добавляем больше возможных статусов
            if (payload.status === "success" &&
                (payload.result_status === "text_generated" ||
                    payload.result_status === "edited" ||
                    payload.result_status === "created_custom" ||
                    payload.result_status === "completed")) {
                console.log("WebSocket notification success, fetching object");
                // Отписываемся от уведомлений
                wsManager.unsubscribe(wsEventId);
                // Очищаем таймаут
                if (timeoutId) {
                    clearTimeout(timeoutId);
                }
                try {
                    // Определяем тип объекта по типу уведомления
                    const notificationType = payload.type;
                    console.log("Notification type:", notificationType, "Result status:", payload.result_status);
                    // Если это уведомление о тексте или результат связан с текстом, получаем текст
                    if (notificationType === "text" ||
                        payload.result_status === "text_generated" ||
                        payload.result_status === "created_custom" ||
                        payload.result_status === "edited" ||
                        payload.result_status === "completed") {
                        // Это уведомление о тексте - получаем текст
                        console.log("Fetching text by ID:", payload.object_id);
                        const text = await getTextById(payload.object_id);
                        console.log("Text received from API:", text);
                        // Преобразуем текст в формат SongHistoryItem для совместимости
                        const song = {
                            id: text.id,
                            title: text.title || "",
                            text: text.text,
                            status: text.status,
                            text_id: text.id,
                            recipient: typeof text.recipient === "string" ? text.recipient : undefined,
                            reason: typeof text.reason === "string" ? text.reason : undefined,
                            about: text.about || undefined,
                            audios: [], // Текст еще не имеет аудио
                            created_at: text.created_at,
                        };
                        resolve(song);
                    }
                    else {
                        // Это уведомление о песне - получаем песню
                        console.log("Fetching song by ID:", payload.object_id);
                        const song = await getSongById(payload.object_id);
                        console.log("Song received from API:", song);
                        // Убеждаемся, что у песни есть ID
                        if (!song || !song.id) {
                            console.error("Song missing ID:", song);
                            reject(new Error("Song received from API is missing ID"));
                            return;
                        }
                        // Если у песни нет text_id, но есть id, используем id как text_id
                        // (это может быть случай, когда песня еще не создана, но текст есть)
                        if (!song.text_id && song.id) {
                            console.log("Song missing text_id, using id as text_id:", song.id);
                            song.text_id = song.id;
                        }
                        resolve(song);
                    }
                }
                catch (error) {
                    console.error("Error fetching object after generation:", error);
                    reject(new Error(error.response?.data?.detail ||
                        error.message ||
                        "Failed to fetch object after generation"));
                }
            }
            else if (payload.status === "error") {
                console.log("WebSocket notification error:", payload.result_status);
                // Отписываемся от уведомлений
                wsManager.unsubscribe(wsEventId);
                // Очищаем таймаут
                if (timeoutId) {
                    clearTimeout(timeoutId);
                }
                tryOpenTopUpFromWsPayload(payload);
                // Возвращаем ошибку
                reject(new Error(`Generation failed: ${payload.result_status || "Unknown error"}`));
            }
            else {
                console.log("WebSocket notification status not handled, waiting...", {
                    status: payload.status,
                    result_status: payload.result_status,
                });
                // Если статус другой, просто ждем дальше
            }
        });
        // Убеждаемся, что WebSocket подключен
        if (!wsManager.isConnected()) {
            wsManager
                .connect()
                .catch((error) => {
                if (timeoutId) {
                    clearTimeout(timeoutId);
                }
                wsManager.unsubscribe(wsEventId);
                reject(error);
            });
        }
    });
};
// Создание текста из кастомного текста (соответствует /api/v1/public/texts/from-custom-text)
export const createSongFromCustomText = async (data) => {
    const initData = getAnyInitData();
    const headers = {};
    if (initData) {
        headers[getInitDataHeaderName()] = initData;
    }
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
        headers["Authorization"] = `Bearer ${accessToken}`;
    }
    const response = await api.post("/api/v1/public/texts/from-custom-text", data, {
        headers,
    });
    return response.data;
};
export const editSong = async (songId, data) => {
    const initData = getAnyInitData();
    const headers = {};
    if (initData) {
        headers[getInitDataHeaderName()] = initData;
    }
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
        headers["Authorization"] = `Bearer ${accessToken}`;
    }
    const response = await api.patch(`/api/v1/public/songs/${songId}/edit`, data, {
        headers,
    });
    return response.data;
};
/**
 * Прямое редактирование текста (соответствует /api/v1/public/texts/{id}/edit-direct)
 * Возвращает PublicTextResponse, но мы используем SongHistoryItem для совместимости
 */
export const editSongDirect = async (textId, data) => {
    const initData = getAnyInitData();
    const headers = {};
    if (initData) {
        headers[getInitDataHeaderName()] = initData;
    }
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
        headers["Authorization"] = `Bearer ${accessToken}`;
    }
    const response = await api.post(`/api/v1/public/texts/${textId}/edit-direct`, data, {
        headers,
    });
    return response.data;
};
/**
 * Редактирование текста с помощью ИИ (соответствует /api/v1/public/texts/{id}/edit-with-ai)
 */
export const editSongWithAI = async (textId, data) => {
    const initData = getAnyInitData();
    const headers = {};
    if (initData) {
        headers[getInitDataHeaderName()] = initData;
    }
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
        headers["Authorization"] = `Bearer ${accessToken}`;
    }
    const response = await api.post(`/api/v1/public/texts/${textId}/edit-with-ai`, data, {
        headers,
    });
    return response.data;
};
/**
 * Данные аудио по `audio_id` для `/share` (deep-link из бота).
 *
 * Owner-gated на бэкенде (аудио принадлежит текущему юзеру, песня COMPLETED).
 * В отличие от `getSongById`, точка входа — конкретное аудио (вариант песни),
 * которое юзер выбрал в боте; заголовок/обложка/url нужны `ShareEditorModal`.
 */
export const getAudioSharePreview = async (audioId) => {
    const initData = getAnyInitData();
    const headers = {};
    if (initData) {
        headers[getInitDataHeaderName()] = initData;
    }
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
        headers["Authorization"] = `Bearer ${accessToken}`;
    }
    const response = await api.get(`/api/v1/public/audios/${audioId}/share-preview`, {
        headers,
    });
    return response.data;
};
export const getSongById = async (songId) => {
    const initData = getAnyInitData();
    const headers = {};
    if (initData) {
        headers[getInitDataHeaderName()] = initData;
    }
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
        headers["Authorization"] = `Bearer ${accessToken}`;
    }
    const response = await api.get(`/api/v1/public/songs/${songId}`, {
        headers,
    });
    console.log("getSongById response:", response.data);
    const song = response.data;
    // Убеждаемся, что у песни есть ID
    if (!song || !song.id) {
        console.error("Song missing ID in response:", song);
        throw new Error("Song received from API is missing ID");
    }
    // Если у песни нет text_id, но API вернул его в ответе, используем его
    // Согласно Swagger, PublicSongResponse содержит text_id
    if (!song.text_id && song.text_id !== undefined) {
        song.text_id = song.text_id;
    }
    return song;
};
export const getTextById = async (textId) => {
    const initData = getAnyInitData();
    const headers = {};
    if (initData) {
        headers[getInitDataHeaderName()] = initData;
    }
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
        headers["Authorization"] = `Bearer ${accessToken}`;
    }
    const response = await api.get(`/api/v1/public/texts/${textId}`, {
        headers,
    });
    console.log("getTextById response:", response.data);
    return response.data;
};
// Генерация музыки (соответствует /api/v1/public/songs/generate-music)
export const generateMusic = async (data) => {
    const initData = getAnyInitData();
    const headers = {};
    if (initData) {
        headers[getInitDataHeaderName()] = initData;
    }
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
        headers["Authorization"] = `Bearer ${accessToken}`;
    }
    const response = await api.post("/api/v1/public/songs/generate-music", data, {
        headers,
    });
    return response.data;
};
// Поиск настроений (соответствует /api/v1/public/songs/moods/search)
export const searchMoods = async (params) => {
    const initData = getAnyInitData();
    const headers = {};
    if (initData) {
        headers[getInitDataHeaderName()] = initData;
    }
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
        headers["Authorization"] = `Bearer ${accessToken}`;
    }
    const response = await api.post("/api/v1/public/songs/moods/search", params || {}, {
        headers,
    });
    return response.data.results || [];
};
// Поиск инструментов (соответствует /api/v1/public/songs/instruments/search)
export const searchInstruments = async (params) => {
    const initData = getAnyInitData();
    const headers = {};
    if (initData) {
        headers[getInitDataHeaderName()] = initData;
    }
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
        headers["Authorization"] = `Bearer ${accessToken}`;
    }
    const response = await api.post("/api/v1/public/songs/instruments/search", params || {}, {
        headers,
    });
    return response.data.results || [];
};
/**
 * Ожидает результат генерации музыки через WebSocket
 * @param wsEventId - ID события WebSocket
 * @param onSuccess - Callback при успешной генерации
 * @param onError - Callback при ошибке
 * @param timeout - Таймаут в миллисекундах (по умолчанию 10 минут)
 * @returns Функция отмены: снимает таймаут и подписку WS (например, после догона по API)
 */
export const waitForMusicGeneration = (wsEventId, onSuccess, onError, timeout = 10 * 60 * 1000) => {
    let timeoutId = null;
    const dispose = () => {
        if (timeoutId !== null) {
            clearTimeout(timeoutId);
            timeoutId = null;
        }
        wsManager.unsubscribe(wsEventId);
    };
    timeoutId = setTimeout(() => {
        dispose();
        onError("Timeout waiting for music generation");
    }, timeout);
    wsManager.subscribe(wsEventId, (notification) => {
        const payload = notification.payload;
        if (payload.ws_event_id !== wsEventId) {
            return;
        }
        const musicReady = payload.status === "success" &&
            (payload.result_status === "music_generated" ||
                payload.result_status === "completed");
        if (musicReady) {
            dispose();
            const result = onSuccess("Music generated successfully");
            if (result instanceof Promise) {
                result.catch((error) => {
                    console.error("Error in onSuccess callback:", error);
                });
            }
        }
        else if (payload.status === "error") {
            dispose();
            tryOpenTopUpFromWsPayload(payload);
            onError(`Music generation failed: ${payload.result_status || "Unknown error"}`);
        }
    });
    if (!wsManager.isConnected()) {
        wsManager.connect().catch((error) => {
            dispose();
            onError(`Failed to connect WebSocket: ${error.message}`);
        });
    }
    return dispose;
};
export const getCharts = async (params) => {
    const initData = getAnyInitData();
    const headers = {};
    if (initData) {
        headers[getInitDataHeaderName()] = initData;
    }
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
        headers["Authorization"] = `Bearer ${accessToken}`;
    }
    const response = await api.post("/api/v1/public/songs/charts/search", {
        type: params.type,
        limit: params.limit || 20,
        offset: params.offset || 0,
    }, {
        headers,
    });
    return response.data;
};
// Like/Unlike API
export const likeAudio = async (audioId) => {
    const initData = getAnyInitData();
    const headers = {};
    if (initData) {
        headers[getInitDataHeaderName()] = initData;
    }
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
        headers["Authorization"] = `Bearer ${accessToken}`;
    }
    await api.post(`/api/v1/public/audios/${audioId}/like`, {}, {
        headers,
    });
};
export const unlikeAudio = async (audioId) => {
    const initData = getAnyInitData();
    const headers = {};
    if (initData) {
        headers[getInitDataHeaderName()] = initData;
    }
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
        headers["Authorization"] = `Bearer ${accessToken}`;
    }
    await api.delete(`/api/v1/public/audios/${audioId}/like`, {
        headers,
    });
};
/** Заказать генерацию минуса аудио (спишет 1 SONGS у worker'а). */
export const requestInstrumental = async (audioId) => {
    const initData = getAnyInitData();
    const headers = {};
    if (initData) {
        headers[getInitDataHeaderName()] = initData;
    }
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
        headers["Authorization"] = `Bearer ${accessToken}`;
    }
    const res = await api.post(`/api/v1/public/audios/${audioId}/instrumental`, {}, {
        headers,
    });
    return res.data;
};
/** Переименовать аудио (поварьянтно). Сервер тримит title до 100 символов и
 *  возвращает итоговое значение. Owner-scope. */
export const renameAudio = async (audioId, title) => {
    const initData = getAnyInitData();
    const headers = {};
    if (initData) {
        headers[getInitDataHeaderName()] = initData;
    }
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
        headers["Authorization"] = `Bearer ${accessToken}`;
    }
    const res = await api.patch(`/api/v1/public/audios/${audioId}/title`, { title }, {
        headers,
    });
    return res.data;
};
// Заголовки авторизации (initData/Bearer) для owner-gated ручек аудио. Вынесено,
// чтобы не дублировать в каждом коротком мутаторе ниже.
const authHeaders = () => {
    const headers = {};
    const initData = getAnyInitData();
    if (initData) {
        headers[getInitDataHeaderName()] = initData;
    }
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
        headers["Authorization"] = `Bearer ${accessToken}`;
    }
    return headers;
};
/**
 * Добавить аудио в приватное избранное текущего юзера (≠ публичный лайк чартов).
 * Модель стемов-строк (батч 16): избранное — отдельная сущность `audio_favorites`.
 */
export const favoriteAudio = async (audioId) => {
    await api.post(`/api/v1/public/audios/${audioId}/favorite`, {}, { headers: authHeaders() });
};
/** Убрать аудио из приватного избранного. */
export const unfavoriteAudio = async (audioId) => {
    await api.delete(`/api/v1/public/audios/${audioId}/favorite`, {
        headers: authHeaders(),
    });
};
/**
 * Скрыть/показать аудио на странице автора (тумблер `is_show`). Скрытые строки
 * владелец видит в «Моей музыке» с бейджем; в публичных списках/чартах их нет.
 */
export const setAudioShowStatus = async (audioId, isShow) => {
    await api.patch(`/api/v1/public/audios/${audioId}/show-status`, { is_show: isShow }, { headers: authHeaders() });
};
/**
 * Удалить аудио (soft-delete). Каскадит на дочерние стемы (минус/вокал) на
 * бэке — удаление строки-песни убирает и её стемы.
 */
export const deleteAudio = async (audioId) => {
    await api.delete(`/api/v1/public/audios/${audioId}`, {
        headers: authHeaders(),
    });
};
/**
 * Ждать готовности минуса через WebSocket (как `waitForMusicGeneration`).
 * Возвращает функцию отмены (снимает таймаут и подписку).
 */
export const waitForInstrumental = (wsEventId, onReady, onError, timeout = 5 * 60 * 1000) => {
    let timeoutId = null;
    const dispose = () => {
        if (timeoutId !== null) {
            clearTimeout(timeoutId);
            timeoutId = null;
        }
        wsManager.unsubscribe(wsEventId);
    };
    timeoutId = setTimeout(() => {
        dispose();
        onError("Timeout waiting for instrumental");
    }, timeout);
    wsManager.subscribe(wsEventId, (notification) => {
        const payload = notification.payload;
        // wsManager уже роутит по ws_event_id, но перестрахуемся.
        if (payload.ws_event_id !== wsEventId)
            return;
        if (payload.status === "success") {
            dispose();
            const result = onReady();
            if (result instanceof Promise) {
                result.catch((e) => console.error("waitForInstrumental onReady:", e));
            }
        }
        else if (payload.status === "error") {
            dispose();
            onError("Instrumental generation failed");
        }
    });
    if (!wsManager.isConnected()) {
        wsManager.connect().catch((error) => {
            dispose();
            onError(`Failed to connect WebSocket: ${error.message}`);
        });
    }
    return dispose;
};
/** Текущий статус минуса аудио (для поллинга/догона). */
export const getInstrumentalStatus = async (audioId) => {
    const initData = getAnyInitData();
    const headers = {};
    if (initData) {
        headers[getInitDataHeaderName()] = initData;
    }
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
        headers["Authorization"] = `Bearer ${accessToken}`;
    }
    const res = await api.get(`/api/v1/public/audios/${audioId}/instrumental`, {
        headers,
    });
    return res.data;
};
/** Заказать конвертацию аудио в WAV (бесплатно, без списания). */
export const requestWav = async (audioId) => {
    const initData = getAnyInitData();
    const headers = {};
    if (initData) {
        headers[getInitDataHeaderName()] = initData;
    }
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
        headers["Authorization"] = `Bearer ${accessToken}`;
    }
    const res = await api.post(`/api/v1/public/audios/${audioId}/wav`, {}, {
        headers,
    });
    return res.data;
};
/**
 * Ждать готовности WAV через WebSocket (как `waitForInstrumental`).
 * Возвращает функцию отмены (снимает таймаут и подписку).
 */
export const waitForWav = (wsEventId, onReady, onError, timeout = 5 * 60 * 1000) => {
    let timeoutId = null;
    const dispose = () => {
        if (timeoutId !== null) {
            clearTimeout(timeoutId);
            timeoutId = null;
        }
        wsManager.unsubscribe(wsEventId);
    };
    timeoutId = setTimeout(() => {
        dispose();
        onError("Timeout waiting for wav");
    }, timeout);
    wsManager.subscribe(wsEventId, (notification) => {
        const payload = notification.payload;
        // wsManager уже роутит по ws_event_id, но перестрахуемся.
        if (payload.ws_event_id !== wsEventId)
            return;
        if (payload.status === "success") {
            dispose();
            const result = onReady();
            if (result instanceof Promise) {
                result.catch((e) => console.error("waitForWav onReady:", e));
            }
        }
        else if (payload.status === "error") {
            dispose();
            onError("Wav conversion failed");
        }
    });
    if (!wsManager.isConnected()) {
        wsManager.connect().catch((error) => {
            dispose();
            onError(`Failed to connect WebSocket: ${error.message}`);
        });
    }
    return dispose;
};
/** Текущий статус WAV аудио (для поллинга/догона). */
export const getWavStatus = async (audioId) => {
    const initData = getAnyInitData();
    const headers = {};
    if (initData) {
        headers[getInitDataHeaderName()] = initData;
    }
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
        headers["Authorization"] = `Bearer ${accessToken}`;
    }
    const res = await api.get(`/api/v1/public/audios/${audioId}/wav`, {
        headers,
    });
    return res.data;
};
/** Заказать продление аудио (спишет 1 SONGS). Результат — новый вариант песни. */
export const requestExtend = async (audioId, data) => {
    const initData = getAnyInitData();
    const headers = {};
    if (initData) {
        headers[getInitDataHeaderName()] = initData;
    }
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
        headers["Authorization"] = `Bearer ${accessToken}`;
    }
    const res = await api.post(`/api/v1/public/audios/${audioId}/extend`, data, {
        headers,
    });
    return res.data;
};
/**
 * Ждать готовности продления через WebSocket (как `waitForWav`). Тип WS-события —
 * `song_extend`; wsManager роутит по ws_event_id. Возвращает функцию отмены
 * (снимает таймаут и подписку).
 */
export const waitForExtend = (wsEventId, onReady, onError, timeout = 5 * 60 * 1000) => {
    let timeoutId = null;
    const dispose = () => {
        if (timeoutId !== null) {
            clearTimeout(timeoutId);
            timeoutId = null;
        }
        wsManager.unsubscribe(wsEventId);
    };
    timeoutId = setTimeout(() => {
        dispose();
        onError("Timeout waiting for extend");
    }, timeout);
    wsManager.subscribe(wsEventId, (notification) => {
        const payload = notification.payload;
        // wsManager уже роутит по ws_event_id, но перестрахуемся.
        if (payload.ws_event_id !== wsEventId)
            return;
        if (payload.status === "success") {
            dispose();
            const result = onReady();
            if (result instanceof Promise) {
                result.catch((e) => console.error("waitForExtend onReady:", e));
            }
        }
        else if (payload.status === "error") {
            dispose();
            onError("Song extend failed");
        }
    });
    if (!wsManager.isConnected()) {
        wsManager.connect().catch((error) => {
            dispose();
            onError(`Failed to connect WebSocket: ${error.message}`);
        });
    }
    return dispose;
};
/** Текущий статус продления аудио (для поллинга/догона). */
export const getExtendStatus = async (audioId) => {
    const initData = getAnyInitData();
    const headers = {};
    if (initData) {
        headers[getInitDataHeaderName()] = initData;
    }
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
        headers["Authorization"] = `Bearer ${accessToken}`;
    }
    const res = await api.get(`/api/v1/public/audios/${audioId}/extend`, {
        headers,
    });
    return res.data;
};
/**
 * Загрузить одно фото для видеообложки (multipart, поле `file`). Грузим 2–50
 * фото по одному, собираем `key` каждого в `photo_keys`. Content-Type снимаем
 * (undefined), чтобы браузер сам выставил multipart-boundary (как uploadSharePhoto).
 */
export const uploadVideoCoverPhoto = async (audioId, file) => {
    const initData = getAnyInitData();
    const headers = {};
    if (initData) {
        headers[getInitDataHeaderName()] = initData;
    }
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
        headers["Authorization"] = `Bearer ${accessToken}`;
    }
    const formData = new FormData();
    formData.append("file", file);
    const res = await api.post(`/api/v1/public/audios/${audioId}/video-cover/photos`, formData, {
        // Content-Type снимаем, чтобы браузер выставил multipart-boundary сам.
        headers: { ...headers, "Content-Type": undefined },
    });
    return res.data;
};
/** Заказать рендер видеообложки (спишет 1 SONGS). Результат — mp4 по WS-готовности. */
export const requestVideoCover = async (audioId, data) => {
    const initData = getAnyInitData();
    const headers = {};
    if (initData) {
        headers[getInitDataHeaderName()] = initData;
    }
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
        headers["Authorization"] = `Bearer ${accessToken}`;
    }
    const res = await api.post(`/api/v1/public/audios/${audioId}/video-cover`, data, {
        headers,
    });
    return res.data;
};
/**
 * Ждать готовности видеообложки через WebSocket (как `waitForWav`). Тип WS-события
 * — `song_video_cover`; wsManager роутит по ws_event_id. Возвращает функцию
 * отмены (снимает таймаут и подписку).
 */
export const waitForVideoCover = (wsEventId, onReady, onError, timeout = 5 * 60 * 1000) => {
    let timeoutId = null;
    const dispose = () => {
        if (timeoutId !== null) {
            clearTimeout(timeoutId);
            timeoutId = null;
        }
        wsManager.unsubscribe(wsEventId);
    };
    timeoutId = setTimeout(() => {
        dispose();
        onError("Timeout waiting for video cover");
    }, timeout);
    wsManager.subscribe(wsEventId, (notification) => {
        const payload = notification.payload;
        // wsManager уже роутит по ws_event_id, но перестрахуемся.
        if (payload.ws_event_id !== wsEventId)
            return;
        if (payload.status === "success") {
            dispose();
            const result = onReady();
            if (result instanceof Promise) {
                result.catch((e) => console.error("waitForVideoCover onReady:", e));
            }
        }
        else if (payload.status === "error") {
            dispose();
            onError("Video cover render failed");
        }
    });
    if (!wsManager.isConnected()) {
        wsManager.connect().catch((error) => {
            dispose();
            onError(`Failed to connect WebSocket: ${error.message}`);
        });
    }
    return dispose;
};
/** Текущий статус видеообложки аудио (для поллинга/догона). */
export const getVideoCoverStatus = async (audioId) => {
    const initData = getAnyInitData();
    const headers = {};
    if (initData) {
        headers[getInitDataHeaderName()] = initData;
    }
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
        headers["Authorization"] = `Bearer ${accessToken}`;
    }
    const res = await api.get(`/api/v1/public/audios/${audioId}/video-cover`, {
        headers,
    });
    return res.data;
};
/**
 * Загрузить одно фото для караоке-клипа (multipart, поле `file`). Грузим 2–50
 * фото по одному, собираем `key` каждого в `photo_keys`. Content-Type снимаем
 * (undefined), чтобы браузер сам выставил multipart-boundary (как uploadVideoCoverPhoto).
 */
export const uploadKaraokePhoto = async (audioId, file) => {
    const initData = getAnyInitData();
    const headers = {};
    if (initData) {
        headers[getInitDataHeaderName()] = initData;
    }
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
        headers["Authorization"] = `Bearer ${accessToken}`;
    }
    const formData = new FormData();
    formData.append("file", file);
    const res = await api.post(`/api/v1/public/audios/${audioId}/karaoke/photos`, formData, {
        // Content-Type снимаем, чтобы браузер выставил multipart-boundary сам.
        headers: { ...headers, "Content-Type": undefined },
    });
    return res.data;
};
/** Заказать рендер караоке-клипа (спишет 1 SONGS). Результат — mp4 по WS-готовности. */
export const requestKaraoke = async (audioId, data) => {
    const initData = getAnyInitData();
    const headers = {};
    if (initData) {
        headers[getInitDataHeaderName()] = initData;
    }
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
        headers["Authorization"] = `Bearer ${accessToken}`;
    }
    const res = await api.post(`/api/v1/public/audios/${audioId}/karaoke`, data, {
        headers,
    });
    return res.data;
};
/**
 * Ждать готовности караоке через WebSocket (как `waitForVideoCover`). Тип
 * WS-события — `song_karaoke`; wsManager роутит по ws_event_id. Возвращает
 * функцию отмены (снимает таймаут и подписку).
 */
export const waitForKaraoke = (wsEventId, onReady, onError, timeout = 5 * 60 * 1000) => {
    let timeoutId = null;
    const dispose = () => {
        if (timeoutId !== null) {
            clearTimeout(timeoutId);
            timeoutId = null;
        }
        wsManager.unsubscribe(wsEventId);
    };
    timeoutId = setTimeout(() => {
        dispose();
        onError("Timeout waiting for karaoke");
    }, timeout);
    wsManager.subscribe(wsEventId, (notification) => {
        const payload = notification.payload;
        // wsManager уже роутит по ws_event_id, но перестрахуемся.
        if (payload.ws_event_id !== wsEventId)
            return;
        if (payload.status === "success") {
            dispose();
            const result = onReady();
            if (result instanceof Promise) {
                result.catch((e) => console.error("waitForKaraoke onReady:", e));
            }
        }
        else if (payload.status === "error") {
            dispose();
            onError("Karaoke render failed");
        }
    });
    if (!wsManager.isConnected()) {
        wsManager.connect().catch((error) => {
            dispose();
            onError(`Failed to connect WebSocket: ${error.message}`);
        });
    }
    return dispose;
};
/** Текущий статус караоке-клипа аудио (для поллинга/догона). */
export const getKaraokeStatus = async (audioId) => {
    const initData = getAnyInitData();
    const headers = {};
    if (initData) {
        headers[getInitDataHeaderName()] = initData;
    }
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
        headers["Authorization"] = `Bearer ${accessToken}`;
    }
    const res = await api.get(`/api/v1/public/audios/${audioId}/karaoke`, {
        headers,
    });
    return res.data;
};
export const updateAudioChartsVisibility = async (audioId, data) => {
    const initData = getAnyInitData();
    const headers = {};
    if (initData) {
        headers[getInitDataHeaderName()] = initData;
    }
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
        headers["Authorization"] = `Bearer ${accessToken}`;
    }
    await api.patch(`/api/v1/public/audios/${audioId}/charts-visibility`, data, {
        headers,
    });
};
/**
 * Публичное чтение песни по токену (без auth). Путь — `/public/songs/by-token/
 * {token}` (отдельный сегмент `by-token`, чтобы не коллизировать с authed
 * `GET /public/songs/{song_id}`, как и у shares). 404 — токен неизвестен/
 * невалиден ИЛИ песня ещё не готова (не COMPLETED).
 */
export const getPublicSongByToken = async (token) => {
    const response = await api.get(`/api/v1/public/songs/by-token/${encodeURIComponent(token)}`);
    return response.data;
};
/**
 * Прямая (presigned) ссылка на скачивание публичной песни по токену. Бэк
 * отдаёт `{ url }` на объект в хранилище с `Content-Disposition: attachment` —
 * файл качается напрямую, без стрима через бэк. Без auth (по токену).
 */
export const getPublicSongDownloadUrl = async (token) => {
    const response = await api.get(`/api/v1/public/songs/by-token/${encodeURIComponent(token)}/download-url`);
    return response.data.url;
};
/**
 * Прямая (presigned) ссылка на скачивание МЕДИА публичной песни по токену:
 * минус / WAV / видеообложка / караоке. Зеркало `getPublicSongDownloadUrl`, но
 * с сегментом типа медиа и (для video-cover/karaoke с несколькими версиями)
 * `media_output_id`. Бэк отдаёт `{ url }` с `Content-Disposition: attachment`.
 * Без auth (по токену) — всё публично.
 */
export const getPublicSongMediaDownloadUrl = async (token, kind, mediaOutputId) => {
    const query = mediaOutputId != null ? `?media_output_id=${mediaOutputId}` : "";
    const response = await api.get(`/api/v1/public/songs/by-token/${encodeURIComponent(token)}/${kind}/download-url${query}`);
    return response.data.url;
};
/**
 * Публичный токен страницы песни для СВОЕГО аудио (owner-gated). Фронт строит из
 * него ссылку `{origin}/song/{token}` — ту же, что MAX/VK-боты шлют получателю.
 * Используется для «скачивания» в мини-аппах: открыть публичную страницу во
 * внешнем браузере надёжнее прямого скачивания mp3 (в вебвью оно редиректит/
 * проигрывает). Токен создаётся лениво и идемпотентно на бэке.
 */
export const getAudioPublicToken = async (audioId) => {
    const response = await api.get(`/api/v1/public/audios/${audioId}/public-token`);
    return response.data.token;
};
export const searchTexts = async (params) => {
    const initData = getAnyInitData();
    const headers = {};
    if (initData) {
        headers[getInitDataHeaderName()] = initData;
    }
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
        headers["Authorization"] = `Bearer ${accessToken}`;
    }
    const response = await api.post("/api/v1/public/texts/search", params || {}, {
        headers,
    });
    return response.data;
};
